export default function PreferencesPage() {
  return (
    <main className="tab-main untab">
      <section className="wip-section">
        <h1>Oops, I'm a Preferences Tab in progress. Try other tabs?</h1>
      </section>
    </main>
  );
}
